import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './accolades-list-blocks.component.scss';
var AccoladesListBlocks = /** @class */ (function (_super) {
    tslib_1.__extends(AccoladesListBlocks, _super);
    function AccoladesListBlocks(element) {
        return _super.call(this, element) || this;
    }
    AccoladesListBlocks.prototype.init = function () {
        this.form = this.element.querySelector('#accolades-list-filter');
        this.selectButtons = Array.from(this.element.querySelectorAll('.accolades-list__form-field--select-button'));
        this.selectItems = Array.from(this.element.querySelectorAll('.accolades-list__form-field--select-box-item'));
        this.clearButton = this.element.querySelector('.js-clear-filters');
    };
    AccoladesListBlocks.prototype.bindEvents = function () {
        var _this = this;
        if (this.selectButtons) {
            this.selectButtons.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                _this.closeAllSelects();
                var parent = element.closest('.accolades-list__form-field--container');
                var box = parent.querySelector('.accolades-list__form-field--select-box');
                box.classList.toggle('accolades-list__form-field--select-box-active');
            }); });
        }
        if (this.selectItems) {
            this.selectItems.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var value = element.getAttribute('data-value');
                var name = element.getAttribute('data-name');
                var parent = element.closest('.accolades-list__form-field--container');
                var button = parent.querySelector('.accolades-list__form-field--select-button');
                var box = parent.querySelector('.accolades-list__form-field--select-box');
                button.innerHTML = name;
                box.classList.toggle('accolades-list__form-field--select-box-active');
            }); });
        }
        if (this.clearButton) {
            this.clearButton.addEventListener('click', function (event) {
                _this.form.reset();
            });
        }
    };
    AccoladesListBlocks.prototype.closeAllSelects = function () {
        this.selectButtons.map(function (item) {
            var element = item;
            var parent = element.closest('.accolades-list__form-field--container');
            var box = parent.querySelector('.accolades-list__form-field--select-box');
            box.classList.remove('accolades-list__form-field--select-box-active');
        });
    };
    return AccoladesListBlocks;
}(Base));
export { AccoladesListBlocks };



//////////////////
// WEBPACK FOOTER
// ./components/accolades-list-blocks/accolades-list-blocks.component.ts
// module id = 73
// module chunks = 0